<template>
    <div class="market-couponGrant-index">
        <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
            <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
        </Search>
        <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :total="total"
            :offset="offset" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
            <template #id="{ row }">{{ row.id }}</template>
            <template #name="{ row }">{{ row.name }}</template>
            <template #phone="{ row, scope }">
            <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
            <auth-button auth="user:phone:read">
              <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
                {{ row.phone_show ? '隐藏' : '查看' }}
              </el-button>
            </auth-button>
            </template>
            <template #startTime="{ row }">{{ row.startTime ? $moment(row.startTime).format('YYYY/MM/DD HH:mm') : '---'
            }}</template>
            <template #count="{ row }">{{ row.count }}</template>
            <template #userTargetType="{ row }">{{ row.userTargetType }}</template>
            <template #status="{ row }">{{ couponTaskStatusObj[row.status] }}</template>
        </Table>
    </div>
</template>
  
<script>
import XLSX from 'xlsx'
import aes from '@/common/aes.js'
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { downFile } from "@/utils";
import { api_getCouponGrantList, api_getCouPonDownloadExcel} from '@/api/market'
import { api_getUserPhone, api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
    name: "marketCouponGrantIndex",
    mixins: [tableList],
    components: {
        AuthButton,
        Search,
        Table,
    },
    data() {
        const startDate = this.$moment().subtract(30, 'days').valueOf() //默认开始时间
        const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
        return {
            renderData: [
                {
                    label: "发券时间",
                    placeholder: ['开始时间','结算时间'],
                    type: "date-range",
                    key: "time",
                    valueFormat: 'timestamp'
                },
                {
                    label: "券名称",
                    placeholder: "请选择券名称",
                    type: "input",
                    key: "name",
                },
                {
                    label: "会员手机号",
                    placeholder: "请输入会员手机号",
                    type: "input",
                    key: "phone",
                },
                {
                    label: "发券状态",
                    type: "select",
                    key: "status",
                    option: [
                        { label: '已完成', value: 'Finished' },
                        { label: '待进行', value: 'New' },
                        { label: '进行中', value: 'Doing' },
                        { label: '失败', value: 'Failed' },
                    ]
                },
            ],
            form: {
                time:[startDate,endDate]
            },
            tableThData: [
                { prop: "name", label: "券名称", minWidth: "180", },
                { prop: "id", label: "券ID", minWidth: "100", },
                { prop: "phone", label: "会员手机号", minWidth: "180", },
                { prop: "startTime", label: "发券时间", minWidth: "180", },
                { prop: "count", label: "发放数量", minWidth: "180", },
                { prop: "status", label: "发券状态", minWidth: "180", },
            ],

            couponTaskStatusObj: {}, // 发券任务状态枚举
            exportLoading: false,
            tableKey: false,
        };
    },
    created() {
        this.getConfig() // 获取config数据
    },
    methods: {
        // 获取config数据
        async getConfig() {
            const { couponTaskStatus } = await api_getConfig('couponTaskStatus')
            let obj = {}
            couponTaskStatus.forEach(item => {
                obj[item.name] = item.desc
            })
            this.couponTaskStatusObj = obj
        },

        // 获取表格列表数据
        async getList() {
            this.loading = true
            const params = {
                ...this.form,
                offset: this.offset,
                limit: this.limit,
                type:2
            }
            params.startTime = this.form.time ? this.form.time[0] : ''
            params.entTime = this.form.time ? this.form.time[1] : ''
            delete params.time;
            this.$router.push({ query: params })
            const data = await api_getCouponGrantList(params)
            console.log('data: ', data);
            this.tableTrData = data.list || []
            this.total = data.count
            this.loading = false
        },

        // 点击查看手机号
        async onLookPhone(row, index) {
            try {
                if (row.phone_show) {
                    delete this.tableTrData[index].phone_show
                } else {
                    const { phone } = await api_getUserPhone({ id: row.userIds })
                    this.tableTrData[index].phone_show = aes.decrypt(phone)
                }
                this.tableKey = !this.tableKey
            } catch (error) { }
        },
        // 导出
        async onExport() {
            this.exportLoading = true
            const params = {
                ...this.form,
                type:2
            }
            params.startTime = this.form.time ? this.form.time[0] : undefined
            params.entTime = this.form.time ? this.form.time[1] : undefined
            delete params.time
            let res = await api_getCouPonDownloadExcel(params)
            downFile(res)
            this.exportLoading = false
            this.$baseMessage('导出成功', 'success')
        },

    },
    watch: {
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponGrant-index {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .fun-btn-box {
        margin-top: 20px;
    }

    .status {
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .del {
        color: #F74A4A;
    }

    .dot-success {
        background: #05c8af;
    }

    .dot-clear {
        background: #F74A4A;
    }

    .dot-ing {
        background: #3775FF;
    }

    .dot-new {
        background: #ccc;
    }

    .code-import-input {
        height: 0px;
        visibility: hidden;
    }
}
</style>
  